import React, { Component } from 'react';
import SchedulleColumnHeader from './SchedulleColumnHeader'
import SchedulleCard from './SchedulleCard'

export default class SchedulleColumn extends Component {

    constructor(props) {
        super(props);
        this.getSum = this.getSum.bind(this);
    }

    getSum() {
        var sum = this.props.works.reduce(((accumulator, w) => accumulator + w.minutes), 0);
        var minutes = (sum % 60);
        if (minutes < 10) minutes = '0' + minutes;
        return Math.floor(sum / 60) + "ч " + minutes + 'м';

    }

    render() {
        return (
            <div className="schedulle-column">
                <SchedulleColumnHeader>{this.props.name} {this.getSum()}</SchedulleColumnHeader>
                {this.props.works.map(w => <SchedulleCard key={w.id} work={w}/>)}
            </div>);
    }
}